import { connect, ConnectedProps } from "react-redux";
import {
  getHotelAvailabilityLodgingIdInFocus,
  getPackagesAvailabilityLodgings,
  getPackagesAvailabilityCallState,
  getIsFilteredHotelAvailabilityLodgingsEmptyAndDoneSearching,
  getAppliedHotelAvailabilityFilterCount,
  getPackagesByLodgingId,
} from "../../reducer/selectors";
import { IStoreState } from "../../../../reducers/types";
import { MobilePackagesHotelAvailability } from "./component";
import { withRouter } from "react-router-dom";
import { Dispatch } from "@reduxjs/toolkit";
import {
  setAmenitiesFilter,
  setFreeCancelFilter,
  setHotelNameFilter,
  setMaxPriceFilter,
  setStarRatingsFilter,
} from "../../actions/actions";
import { initialFilterState } from "../../reducer";
import { getDestination } from "../../../search/reducer";

const mapStateToProps = (state: IStoreState) => {
  const lodgingIdInFocus = getHotelAvailabilityLodgingIdInFocus(state);
  const lodgings = getPackagesAvailabilityLodgings(state);
  const hotelAvailabilityCallState = getPackagesAvailabilityCallState(state);
  const isFilteredHotelAvailabilityLodgingsEmpty =
    getIsFilteredHotelAvailabilityLodgingsEmptyAndDoneSearching(state);
  return {
    lodgingIdInFocus,
    lodgings,
    hotelAvailabilityCallState,
    isFilteredHotelAvailabilityLodgingsEmpty,
    appliedFilterCount: getAppliedHotelAvailabilityFilterCount(state),
    packagesByLodgingId: getPackagesByLodgingId(state),
    destination: getDestination(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    resetFilters: () => {
      dispatch(setAmenitiesFilter(initialFilterState.amenities));
      dispatch(setFreeCancelFilter(initialFilterState.freeCancel));
      dispatch(setStarRatingsFilter(initialFilterState.starRatings));
      dispatch(setHotelNameFilter(initialFilterState.hotelName));
      dispatch(setMaxPriceFilter(initialFilterState.maxPrice));
    },
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type MobilePackagesHotelAvailabilityConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedMobilePackagesHotelAvailability = withRouter(
  connector(MobilePackagesHotelAvailability)
);
